import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

firebase.initializeApp({
  apiKey: 'AIzaSyA4T4Od1q_0-rBTbMFuuwWIyavlneD4m7o',
  authDomain: 'nctu-mentor-booking.firebaseapp.com',
  databaseURL: 'https://nctu-mentor-booking.firebaseio.com',
  projectId: 'nctu-mentor-booking',
  storageBucket: 'nctu-mentor-booking.appspot.com',
  messagingSenderId: '438545369056',
  appId: '1:438545369056:web:05287bc75c007a8e3b0d85'
})

export const db = firebase.firestore()
export const auth = firebase.auth()

export async function addBooking (data) {
  await db.collection('bookings').add({
    ...data,
    createdAt: firebase.firestore.FieldValue.serverTimestamp()
  })
}

export async function deleteBooking (bookingId) {
  await db.collection('bookings').doc(bookingId).delete()
}

export async function addForm (data) {
  await db.collection('forms').add({
    ...data,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
  })
}

export async function updateForm (formId, data) {
  await db.collection('forms').doc(formId).update({
    ...data,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
  })
}
